import React, { useEffect } from "react";
// routing
import { Routes, Route, BrowserRouter } from "react-router-dom";

// style
import "./css/style.css"

// js
import "./js/main"

// component
import Header from "./component/Header";
import Home from "./component/Home";
import Footer from "./component/Footer";
import Register from "./component/Register";
import Login from "./component/Login";

// types
import { SET_USER, UNSET_USER } from "./store/user/types";

import { IdleTimeoutManager } from "idle-timer-manager";
// redux
import { useDispatch, useSelector } from "react-redux";
import Preference from "./component/Preference";


const App = () => {

  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.user);
  const token = localStorage.getItem("TOKEN");


  useEffect(() => {
    if (!token) return;
    dispatch({ type: SET_USER, payload: token });
  }, [token, dispatch]);

  useEffect(() => {
    const manager = new IdleTimeoutManager({
      timeout: 1800, //30 min (in sec)
      onExpired: (time) => {
        dispatch({ type: UNSET_USER });
        return (window.location.href = "/");
      },
    });

    return () => {
      manager.clear();
    }; //eslint-disable-next-line
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/menu" element={<Preference />} />
          {
            !isAuth &&
            <>
              <Route exact path="/register" element={<Register />} />
              <Route exact path="/login" element={<Login />} />
            </>
          }
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
